import { useInfiniteQuery } from '@tanstack/react-query';
import { PostDataT } from '../types/commonTypes';
import axiosInstance from './axios';
import { PurchaseEntryResponseT } from '../types/purchaseTypes';

export const useInfiniteGetAllPurchase = (postData: PostDataT) => {
  return useInfiniteQuery({
    queryKey: [`useGetAllPurchase`, postData],
    queryFn: async () => {
      const { data } = await axiosInstance.get(
        `/purchase-entry/all?pageSize=${postData.pageSize}&pageNo=${postData.pageNo}&purchaseNumber=${postData.purchaseNumber || ''}`
      );
      return data as PurchaseEntryResponseT & { hasNextPage?: boolean };
    },
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = lastPage.hasNextPage ? allPages.length + 1 : undefined;
      return nextPage;
    },
    initialPageParam: 1,
  });
};
